import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticateService } from 'app/services/authenticate.service';
import { AlertService } from 'app/services/alert.service';
import { MessageService } from 'app/services/message.service';

@Component({
  selector: 'app-universidad',
  templateUrl: './universidad.component.html',
  styleUrls: ['./universidad.component.scss']
})
export class UniversidadComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl: string;
  error = '';
  username: any;
  rol: string;
  loading2= false;

  constructor(private route: ActivatedRoute,private Message: MessageService,
    private router: Router, private authenticateService: AuthenticateService, private alertService: AlertService) {
    this.authenticateService.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

  ngOnInit() {

  }

  login() {
              this.loading = true;
              this.authenticateService.login_univ(this.model.username, this.model.password)
              .subscribe(
                  data => {
                      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                      this.username = currentUser.username;
                      this.rol=currentUser.rol;
                      localStorage.setItem('name',this.username);
                      this.router.navigate([this.returnUrl+"expedientes/2/"+currentUser.conv_defecto]);
                      this.Message.clearWarning();
                      this.Message.clearSuccess();
                      localStorage.setItem('isLoggedin', 'true');

                  },
                  error => {
                      this.Message.addWarning('Usuario o contraseña incorrectos')
                      localStorage.setItem('isLoggedin', 'false');
                      this.loading = false;
                  });

          }

          register() {
            this.loading2 = true;
            this.authenticateService.register_univ(this.model.email_reg)
            .subscribe(
                data => {
                  this.Message.addSuccess(` Correo electrónico enviado correctamente`)
                  this.loading2 = false;
                  this.model.email_reg=""
                },
                error => {
                  this.Message.addWarning(` No se ha recibido ninguna solicitud de acreditación para este solicitante, o no ha sido procesada.`)
                    this.loading2 = false;
                    this.model.email_reg="";
                });

        }


        }




// WEBPACK FOOTER //
// /app/src/app/modules/login/universidad/universidad.component.ts